"use client";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@cmp-src/primitives/Select";
import { IResource } from "@gettactic/api";
import React, { useRef } from "react";

type FloorSelectorProps = {
  floorSelected: IResource;
  changeFloor: (f: IResource) => void;
  multipleFloors: IResource[];
};

export const FloorSelectorMemo = React.memo(FloorSelector);

export function FloorSelector({
  floorSelected,
  changeFloor,
  multipleFloors
}: FloorSelectorProps) {
  const defaultFloorRef = useRef(floorSelected.id);
  function changeHandler(floorId: string) {
    if (multipleFloors) {
      const floor = multipleFloors.find((f) => f.id === floorId);
      if (floor) {
        changeFloor(floor);
      }
    }
  }
  return (
    <Select
      onValueChange={changeHandler}
      defaultValue={defaultFloorRef.current}
    >
      <SelectTrigger className="mt-1 min-h-[42px] min-w-[180px]">
        <SelectValue className="truncate">{floorSelected.name}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {multipleFloors.map((floor, floorIdx) => (
          <SelectItem key={floor.id} value={floor.id}>
            {floor.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
